module.exports = __webpack_public_path__ + "static/media/16UNODC37.b1d37a63.jpg";